import React from 'react';
import {
  QuizTitle,
  QuizSubtitle,
  OptionPill,
  ProgressDots,
  Dot,
  BackButton,
} from '../styles/MFLancamentosStyles';

const QuizQuestion = ({ question, currentStep, totalSteps, onSelect, onBack }) => {
  return (
    <>
      <ProgressDots>
        {Array.from({ length: totalSteps }, (_, i) => (
          <Dot
            key={i}
            $active={i === currentStep}
            $completed={i < currentStep}
          />
        ))}
      </ProgressDots>

      <QuizTitle>{question.title}</QuizTitle>
      <QuizSubtitle>{question.subtitle}</QuizSubtitle>

      {question.options.map((option) => (
        <OptionPill
          key={option.value}
          onClick={() => onSelect(question.id, option.value)}
        >
          {option.label}
        </OptionPill>
      ))}

      {onBack && (
        <BackButton onClick={onBack}>
          ← Voltar
        </BackButton>
      )}
    </>
  );
};

export default QuizQuestion;
